import { defineComponent as u, mergeModels as c, useModel as m, createBlock as f, openBlock as h, resolveDynamicComponent as C, mergeProps as r, unref as e, withCtx as k, createElementVNode as l, normalizeClass as v, withDirectives as x, vModelCheckbox as y } from "vue";
import i from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/DataList/data-list.js";
import { useOUIAProps as B } from "../../helpers/ouia.js";
const M = /* @__PURE__ */ u({
  name: "PfDataListCheck",
  inheritAttrs: !1,
  __name: "DataListCheck",
  props: /* @__PURE__ */ c({
    otherControls: { type: Boolean },
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  }, {
    expanded: { type: Boolean, default: !1 },
    expandedModifiers: {}
  }),
  emits: ["update:expanded"],
  setup(o) {
    const t = o, d = B({ id: t.ouiaId, safe: t.ouiaSafe }), a = m(o, "expanded");
    return (s, n) => (h(), f(C(s.otherControls ? "pass-through" : "div"), r(e(d), {
      class: e(i).dataListItemControl
    }), {
      default: k(() => [
        l("div", {
          class: v(e(i).dataListCheck)
        }, [
          x(l("input", r(s.$attrs, {
            "onUpdate:modelValue": n[0] || (n[0] = (p) => a.value = p),
            type: "checkbox"
          }), null, 16), [
            [y, a.value]
          ])
        ], 2)
      ]),
      _: 1
    }, 16, ["class"]));
  }
});
export {
  M as default
};
